import React from "react";
import { useTranslation } from "react-i18next";
import contact from "./images/PhotoContact.jpg";
import UserIcon from "./images/user.png"; // Import your default user icon image

const ContactCard = ({ name, title, email, imageUrl = UserIcon }) => {
  const { t,  } = useTranslation();
  const handleSendEmail = () => {
    window.location.href = `mailto:${email}`;
  };
  
  return (
    <div className="d-flex align-items-center border rounded p-3 mb-3">
      <div className="flex-grow-1">
     
        <h4>{name}</h4>
        <p className="mb-2">{email}</p>
        <button className="btn btn-sm blue-color-code text-white" onClick={handleSendEmail}>
          {t("send_email")}
        </button>
      </div>
    </div>
  );
};

const ContactList = () => {
  const { t,  } = useTranslation();
  const contacts = [
    {
      email: "contact@my-outsourcing.com",
    },
  ];

  return (
    <>
      <div className="container mt-4">
        {/* Row with image and contact card side by side */}
        <div className="row align-items-center">
          {/* Image column */}
          <div className="col-12 col-md-7 mb-3 mb-md-0 text-center">
            <img
              src={contact}
              className="img-fluid animated"
              alt="contact"
              style={{
                maxHeight: "300px",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Contact Card column */}
          <div className="col-12 col-md-5 animate__animated animate__fadeInDown">
            <h2 className="text-center mb-4"><strong>Contact</strong></h2>
            {contacts.map((contact, index) => (
              <ContactCard key={index} {...contact} />
            ))}
          </div>
        </div>
      </div>

      {/* Map section below */}
      <h2 className="text-center m-4"><strong>{t("location")}</strong></h2>
      <div
        className="mt-4"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px",
        }}
      >
       
        <iframe title="Equipe My outsourcing" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d798.1417386425362!2d10.176055269600507!3d36.85284599826451!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzbCsDUxJzEwLjMiTiAxMMKwMTAnMzYuMSJF!5e0!3m2!1sen!2stn!4v1747494355177!5m2!1sen!2stn" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </>
  );
};


export default ContactList;